async function ComponentSave (componentid, componentcategoryid, componentname, componentdescription, modifiedbyid, deleted, componenttypeid ) {

    if (
        componentcategoryid.length > 0 &&
        componentname.length > 0 &&
        componentdescription.length > 0 &&
        modifiedbyid.length > 0 && 
        deleted.length > 0 
    ) {

            let response;

            response = await fetch ("https://api.cssi.co/query", {
                method: "POST",
                body: JSON.stringify({
                    "sp": "55", 
                    "parameters": {
                        "@ComponentId": componentid,
                        "@ComponentCategoryId": componentcategoryid,
                        "@ComponentName": componentname,
                        "@ComponentDescription": componentdescription,
                        "@ModifiedById": modifiedbyid,
                        "@Deleted": deleted,
                        "@ComponentTypeId": componenttypeid
                    },
                    "servername": "Compass-Svr3\\EXACTSQLEXPRESS", 
                    "databasename": "WebApps", 
                    "continuingfunction": null,
                    "noresults": false, 
                    "args": null
                })
            })
            .then(response => {
                return response.json();
            })
            .catch(e => {
                e.name === "AbortError" ? console.log("Fetch Aborted") : console.log(e.message);        
            })

            return Promise.resolve(response);

    }
}
 
export default ComponentSave;